"use client";

import type * as React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/**
 * Workspaces Switch - HUMANDA Portal
 * Displays the current workspace (HUMANDA portal).
 * In the future, this could support switching between workspaces.
 */
export function WorkspacesSwitch(): React.JSX.Element {
	return (
		<Stack
			direction="row"
			spacing={2}
			sx={{
				alignItems: "center",
				border: "1px solid var(--Workspaces-border-color)",
				borderRadius: "12px",
				p: "4px 8px",
			}}
		>
			<Avatar
				sx={{
					bgcolor: "var(--mui-palette-primary-main)",
					color: "var(--mui-palette-primary-contrastText)",
					fontSize: "0.875rem",
					fontWeight: 600,
					height: 40,
					width: 40,
				}}
				variant="rounded"
			>
				HU
			</Avatar>
			<Box sx={{ flex: "1 1 auto" }}>
				<Typography color="var(--Workspaces-title-color)" variant="caption">
					Workspace
				</Typography>
				<Typography color="var(--Workspaces-name-color)" variant="subtitle2">
					HUMANDA
				</Typography>
			</Box>
		</Stack>
	);
}
